import { ref } from 'vue'
import { useUploadStore } from '@/features/upload/store'
import { useUserStore } from '@/shared/stores/user'
import { apolloClient } from '@/shared/graphql/client'
import {
  FilePrivacy,
  MeDocument,
  useUpdateAccountDefaultFilePrivacyMutation,
  type MeQuery,
} from '@/shared/graphql/legacy/generated'

export function useUploadPrivacy() {
  const uploadStore = useUploadStore()
  const userStore = useUserStore()

  const { mutate: updateAccountDefaultFilePrivacy, loading } =
    useUpdateAccountDefaultFilePrivacyMutation()

  const isPrivate = ref(
    uploadStore.draft?.isPrivate ??
      userStore.user?.defaultFilePrivacy === FilePrivacy.Private
  )

  const persist = async () => {
    const nextPrivacy = isPrivate.value
      ? FilePrivacy.Private
      : FilePrivacy.Public

    if (userStore.user?.defaultFilePrivacy !== nextPrivacy) {
      await updateAccountDefaultFilePrivacy({ isPrivate: isPrivate.value })
    }

    uploadStore.updateDraft({ isPrivate: isPrivate.value })
    markUploaded()
  }

  const markUploaded = () => {
    apolloClient.cache.updateQuery<MeQuery>(
      { query: MeDocument },
      (response) => {
        if (!response) return
        return { ...response, me: { ...response.me, hasUploadedFile: true } }
      }
    )
  }

  return { isPrivate, loading, persist }
}
